// Função de teste personalizado para verificar se o arquivo possui um nome
function hasFileName(value: any): boolean {
  if (value && value.name) {
    return true;
  }
  return false;
}

// Função de teste personalizado para verificar o tamanho do arquivo
function validateFileSize(value: any): boolean {
  const MAX_FILE_SIZE = 3 * 1024 * 1024; // 2MB

  if (value && value.size <= MAX_FILE_SIZE) {
    return true;
  }
  return false;
}

// Função de teste personalizado para verificar o tipo do arquivo
function validateFileType(value: any): boolean {
  if (
    value &&
    (value.type === 'application/pdf' ||
      value.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
  ) {
    return true;
  }
  return false;
}


const getFileFromInput = (file: any): Promise<any> => {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = function () { resolve(reader.result); };
    reader.readAsBinaryString(file); // here the file can be read in different way Text, DataUrl, ArrayBuffer
  });
}

const bytesToSize = (bytes: number, seperator = '', postFix = '') => {
  if (bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.min(parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10), sizes.length - 1);
    return `${(bytes / (1024 ** i)).toFixed(i ? 1 : 0)}${seperator}${sizes[i]}${postFix}`;
  }
  return 'n/a';
}

export { hasFileName, validateFileSize, validateFileType, getFileFromInput, bytesToSize}